import {styled} from '@linaria/react';
import {FONT_SIZES} from '../../../constants/typography';
import {baseCss} from './Text';

const Heading = styled.div`
  ${baseCss}
`;

export const Heading10 = styled(Heading)`
  font-size: ${FONT_SIZES.px10};
`;
export const Heading12 = styled(Heading)`
  font-size: ${FONT_SIZES.px12};
`;
export const Heading14 = styled(Heading)`
  font-size: ${FONT_SIZES.px14};
`;
export const Heading16 = styled(Heading)`
  font-size: ${FONT_SIZES.px16};
`;
export const Heading18 = styled(Heading)`
  font-size: ${FONT_SIZES.px18};
`;
export const Heading20 = styled(Heading)`
  font-size: ${FONT_SIZES.px20};
`;
export const Heading24 = styled(Heading)`
  letter-spacing: 0.3px;
  font-size: ${FONT_SIZES.px24};
`;
export const Heading32 = styled(Heading)`
  letter-spacing: 0.35px;
  font-size: ${FONT_SIZES.px32};
`;
export const Heading40 = styled(Heading)`
  font-weight: 900;
  letter-spacing: 0.4px;
  font-size: ${FONT_SIZES.px40};
`;

export const Heading48 = styled(Heading)`
  font-weight: 900;
  letter-spacing: 0.5px;
  font-size: ${FONT_SIZES.px48};
`;

export const Heading56 = styled(Heading)`
  font-weight: 900;
  letter-spacing: 0.6px;
  font-size: ${FONT_SIZES.px56};
`;
